import { types, actions } from './requests'
export const UPDATEWORK_TYPES = {
    ...types('UPDATEWORK'),
}
export const UPDATEWORK_ACTIONS = {
    ...actions('UPDATEWORK'),
}
